module.exports = __webpack_public_path__ + "img/grimace_ios_802.png";